import { LimitAndClosureScreens } from "../LimitsAndClosure/LimitsAndClosure";

const translateClosureTextToDate = [7, 14, 30, 60, 90, 180, 270];
const translateExclusionTextToDate: {
    [k: string]: number;
} = {
    "0": 180,
    "1": 360,
    P90D: 90,
    // tslint:disable-next-line:object-literal-sort-keys
    P183D: 180,
    P180D: 180,
    P365D: 366,
    P366D: 366,
    P731D: 731,
    P1096D: 1096
};

interface ConfirmationPopupTextProp {
    screen: any;
    previousState: number;
    newState: number;
    dateOfEnd: string | number;
}
export const confirmationPopupText = ({
    screen,
    previousState,
    newState,
    dateOfEnd
}: ConfirmationPopupTextProp) => {
    switch (screen) {
        case LimitAndClosureScreens.lossLimit:
            if (newState >= previousState) {
                return `${screen}.IncreasedLimit`;
            } else {
                return `${screen}.DecreasedLimit`;
            }
        case LimitAndClosureScreens.payInLimit:
            if (newState >= previousState) {
                return `${screen}.IncreasedLimit`;
            } else {
                return `${screen}.DecreasedLimit`;
            }
        case LimitAndClosureScreens.accountClosure:
            if (dateOfEnd < 1) {
                return `${screen}.CloseInfiniteTextMessage`;
            } else {
                return `${screen}.CloseTextMessage`;
            }
        case LimitAndClosureScreens.exclusion:
            if (dateOfEnd === "INDEFINITE" || dateOfEnd > 1) {
                return `${screen}.ExclusionInfiniteMessage`;
            } else {
                return `${screen}.ExclusionTextMessage`;
            }
        default:
            throw Error();
    }
};

export const provideEndDateOfBlock = (
    screen: any,
    endDate: string | number
) => {
    switch (screen) {
        case LimitAndClosureScreens.lossLimit:
        case LimitAndClosureScreens.payInLimit:
            return {};
        case LimitAndClosureScreens.accountClosure:
            endDate = endDate as number;
            return {
                endDate: calculateEndOfClosure(endDate).getDate(),
                endMonth: calculateEndOfClosure(endDate).getMonth() + 1,
                endYear: calculateEndOfClosure(endDate).getFullYear()
            };
        case LimitAndClosureScreens.exclusion:
            if (endDate === "INDEFINITE" || endDate > 1) {
                return {};
            } // Should not calculate for infinite self exclusion
            return {
                endDate: calculateEndOfExclusion(endDate).getDate(),
                endMonth: calculateEndOfExclusion(endDate).getMonth() + 1,
                endYear: calculateEndOfExclusion(endDate).getFullYear()
            };
    }
};

const calculateEndOfClosure = (endDate: number): Date => {
    const actualDay = new Date();
    actualDay.setDate(
        actualDay.getDate() + translateClosureTextToDate[endDate - 1]
    );
    return actualDay;
};

const calculateEndOfExclusion = (endDate: string | number): Date => {
    const actualDay = new Date();
    actualDay.setDate(
        actualDay.getDate() + translateExclusionTextToDate[endDate]
    );
    return actualDay;
};

export default confirmationPopupText;
